@if (currentUser()) {
  @let chatId = (element$ | async)?.id;
  <div class="chat-container">
    @if (showMenu()) {
      <div class="left-col" [class.!min-w-full]="isMobileWidth()">
        <div class="flex gap-16 pb-8 justify-between items-center">
          <blaze-element-header
            [color]="props?.style?.general?.title?.color1"
            [fontFamily]="props?.style?.titleBlock?.fontFamily"
            [fontSize]="props?.style?.titleBlock?.fontSize"
            [fontStyle]="props?.style?.titleBlock?.fontStyle"
            [fontWeight]="props?.style?.titleBlock?.fontWeight"
            [horizontalAlign]="title().align"
            [icon]="title().icon"
            [iconColor]="props?.content?.title?.iconColor?.color1"
            [iconPosition]="props?.content?.title?.iconPosition"
            [iconSize]="props?.style?.titleBlock?.iconSize"
            class="grow"
          >
            {{ title().label }}
          </blaze-element-header>
          @if (addConversationEnabled()) {
            <button
              type="button"
              class="add-button"
              blazeTooltip="Create new conversation"
              data-cy="Chat:createConversation"
              [disabled]="!conversationsLoaded() || isViewAsMode()"
              (click)="onAdd()"
            >
              <mat-icon svgIcon="icon_add_16" />
            </button>
          }
        </div>
        <be-conversations-search (conversationsSearch)="onConversationsSearch($event)" />
        @if (showConversationFilters()) {
          <be-conversations-filters
            [activeFilter]="activeConversationsFilter()"
            (activeFilterChange)="activeConversationsFilter.set($event)"
          />
        }
        @if (showConversationList()) {
          <be-conversations-list
            [conversations]="filteredChatConversationsVM()"
            [allConversationsUnreadMessagesCount]="allConversationsUnreadMessagesCount()"
            [selectedConversationId]="selectedConversationId()"
            [conversationsColors]="colorsMap()"
            (selectedConversationChange)="onSelectedConversationChange($event)"
          />
        } @else if (showSearchResults()) {
          <be-conversations-search-results
            [searchResultsMessages]="searchResultsMessages()"
            [messagesLoading]="searchMessagesLoading()"
            [searchResultsChats]="searchResultsChats()"
            [searchTerm]="searchTerm()"
            (selectedMessageResult)="loadMessageFromSearchResult($event)"
            (selectedChatResult)="onSelectedConversationChange($event)"
          />
        }
      </div>
    }
    <div
      class="right-col"
      [style.border-left-width]="showMenu() && showConversation() ? '1px' : '0'"
    >
      @if (showConversation()) {
        @if (showChatForm()) {
          <div class="h-full">
            <be-chat-form
              [conversation]="selectedConversation()"
              [members]="chatMembersWithoutCurrentUser()"
              [membersColors]="colorsMap()"
              [membersTableName]="membersTableName()"
              (save)="saveConversation($event)"
              (cancel)="closeConversationForm()"
            />
          </div>
        } @else {
          <div class="flex flex-col h-full gap-16">
            @if (!enabledConversationMenu() || selectedConversation()) {
              <div class="conversation-header" data-cy="Chat:conversationHeader">
                @if (!enabledConversationMenu()) {
                  <blaze-element-header
                    [color]="props?.style?.general?.title?.color1"
                    [fontFamily]="props?.style?.titleBlock?.fontFamily"
                    [fontSize]="props?.style?.titleBlock?.fontSize"
                    [fontStyle]="props?.style?.titleBlock?.fontStyle"
                    [fontWeight]="props?.style?.titleBlock?.fontWeight"
                    [horizontalAlign]="title().align"
                    [icon]="title().icon"
                    [iconColor]="props?.content?.title?.iconColor?.color1"
                    [iconPosition]="props?.content?.title?.iconPosition"
                    [iconSize]="props?.style?.titleBlock?.iconSize"
                    class="grow"
                  >
                    {{ title().label }}
                  </blaze-element-header>
                }

                @if (enabledConversationMenu() && selectedConversation(); as conversation) {
                  @if (isMobileWidth() && enabledConversationMenu()) {
                    <button
                      blazeIconButton="skeleton"
                      class="conversation-icon-button"
                      (click)="openMenu()"
                    >
                      <mat-icon svgIcon="icon_chevron_left_16" />
                    </button>
                  }
                  <span class="conversation-label">{{ conversation.displayName }}</span>
                  <div class="flex gap-8">
                    @if (editConversationEnabled()) {
                      <button
                        type="button"
                        class="conversation-icon-button"
                        data-cy="Chat:editConversation"
                        blazeTooltip="Rename the conversation or edit the members"
                        [disabled]="isViewAsMode()"
                        (click)="onEdit()"
                      >
                        <mat-icon svgIcon="icon_edit_24" />
                      </button>
                    }
                    @if (leaveConversationEnabled()) {
                      <button
                        type="button"
                        class="conversation-icon-button"
                        data-cy="Chat:exitConversation"
                        blazeTooltip="Exit the conversation"
                        [disabled]="isViewAsMode()"
                        (click)="onExit()"
                      >
                        <mat-icon svgIcon="exit" />
                      </button>
                    }
                  </div>
                }
              </div>
            }

            @if (selectedConversation()) {
              <be-conversation
                [chatId]="chatId"
                [isMobile]="isMobile || isTablet"
                [createdBy]="selectedConversationCreatedBy()"
                [messages]="chatMessages()"
                [currentUser]="currentUser()"
                [scrollTo]="scrollTo()"
                [lastReadMessageForConversation]="lastReadMessageForConversation()"
                [allMessagesRead]="allMessagesRead()"
                [introImage]="chatIntroImage()"
                [membersColors]="colorsMap()"
                [isEditingEnabled]="enableMessageEdit()"
                [messageAlignment]="messageAlignment()"
                [loadMoreMessagesType]="loadMoreMessagesType()"
                [chatMembersStatuses]="chatMembersStatuses()"
                [isViewAsMode]="isViewAsMode()"
                (lastMessageRead)="markMessageAsRead($event.id)"
                (loadMore)="loadMoreMessages($event)"
              />
              <be-chat-text-input
                [chatId]="chatId"
                [isViewAsMode]="isViewAsMode()"
                [viewAsLabel]="viewAsLabel()"
                [inputDisabled]="isTextInputDisabled()"
                [sendDisabled]="isSendDisabled() || !chatSchemasLoaded()"
                [placeholder]="placeholder()"
                [attachments]="attachments()"
                (addAttachments)="uploadAttachments($event)"
                (deleteAttachment)="deleteAttachment($event)"
                (sendMessage)="confirmSending($event)"
                (updateMessage)="updateMessage($event)"
                (mousedown)="markEventAsHandled($event)"
              />
            } @else if (!isConversationListLoading()) {
              <div class="w-full h-full">
                <blaze-chat-empty-state
                  [disabled]="!conversationsLoaded() || isViewAsMode()"
                  [showAddButton]="addConversationEnabled()"
                  [hasConversations]="chatConversations().length > 0"
                  [menuVisible]="showMenu()"
                  (createNewConversation)="onAdd()"
                  (openMenu)="openMenu()"
                />
              </div>
            }
          </div>
        }
      }
    </div>
    <blaze-element-loading-indicator
      class="absolute left-1/2 top-1/2"
      [isVisible]="showLoadingIndicator()"
      [fadeEnabled]="false"
    />
  </div>
}
